import { parsePhoneNumberFromString, getCountries, getCountryCallingCode } from 'libphonenumber-js';

// Phones are stored in E.164 ("+15135551234"); the API normalizes and validates the same way
// (Utils.normalizePhone). Numbers typed without a country code are read as US, which also covers Canada.

export const PHONE_ERROR = 'Enter a valid phone number, including the area code';

// E.164 for a complete, valid number; null otherwise
export function normalizePhone(value: any, country: any = 'US'): string | null {
    if(value === null || value === undefined || String(value).trim() === '') {
        return null;
    }
    const phone = parsePhoneNumberFromString(String(value).trim(), country);
    return phone && phone.isValid() ? phone.number : null;
}

export function isValidPhone(value: any): boolean {
    return !!normalizePhone(value);
}

// US / Canada as "(513) 555-1234"; everything else in international format ("+44 20 7946 0958")
export function formatPhone(value: any): string {
    if(value === null || value === undefined) {
        return '';
    }
    const phone = parsePhoneNumberFromString(String(value), 'US');
    if(!phone || !phone.isValid()) {
        return String(value);
    }
    return phone.countryCallingCode == '1' ? phone.formatNational() : phone.formatInternational();
}

// Country picker options: US and Canada first, then the rest by name
export function phoneCountries(): { code: string, name: string, dial: string }[] {
    const names = new (Intl as any).DisplayNames(['en'], { type: 'region' });
    const all = getCountries().map(code => ({ code, name: names.of(code) || code, dial: getCountryCallingCode(code) }));
    const pinned = ['US', 'CA'];
    return [
        ...all.filter(c => pinned.includes(c.code)).sort((a, b) => pinned.indexOf(a.code) - pinned.indexOf(b.code)),
        ...all.filter(c => !pinned.includes(c.code)).sort((a, b) => a.name.localeCompare(b.name))
    ];
}
